/**
 * 项目报价实体
 * zxw
 * 创建时间：
 * 修改时间：2026-07-09
 */

import { useState, useEffect } from 'react';
import {
    theme,
    Modal,
    Row,
    Col,
    message,
    Input,
    InputNumber,
    Radio,
    Tabs,
    ConfigProvider,
    Drawer,
    Space,
    Button,
    DatePicker,
    Divider,
    Flex,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    UjoinParams,
    winHeight,
    winWidth,
    currentDate,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

import ProductTable from './ProductTable';
import OfferList from './OfferList';
import TextArea from 'antd/es/input/TextArea';

/** 
* 日期样式
*/
import dayjs from 'dayjs';

const MODULENAME_URL = CNF.navItems[0].submenu[2].url;

const Entity = (props) => {
    const { open, setOpen, record, preGroup, btnLists, refresh } = props;
    const { token: { colorPrimary } } = theme.useToken();

    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [action, setAction] = useState(CNF.actionName.CREATE);
    const [userBasicInfo, setUserBasicInfo] = useState(null);
    const [orgInfo, setOrgInfo] = useState(null);
    const [offerLists, setOfferLists] = useState([]);
    const [name, setName] = useState('');
    const [version, setVersion] = useState(1);
    const [initAmount, setInitAmount] = useState(0);
    const [initTaxAmount, setInitTaxAmount] = useState(0);
    const [amount, setAmount] = useState(0);
    const [taxAmount, setTaxAmount] = useState(0);
    const [offerSorts, setOfferSorts] = useState([{
        number: 1,
        name: '一、项目整体报价',
        rate: 1,
        tax_point: 0,
        amount: 0,
        tax_amount: 0,
    }]);
    const [sortNumber, setSortNumber] = useState(1);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [clientName, setClientName] = useState('');
    const [clientAddress, setClientAddress] = useState('');
    const [clientContacts, setClientContacts] = useState('');
    const [clientPhone, setClientPhone] = useState('');
    const [clientEmail, setClientEmail] = useState('');
    const [offerName, setOfferName] = useState('');
    const [offerAddress, setOfferAddress] = useState('');
    const [offerContacts, setOfferContacts] = useState('');
    const [offerPhone, setOfferPhone] = useState('');
    const [offerEmail, setOfferEmail] = useState('');
    const [offerDate, setOfferDate] = useState(currentDate);
    const [limitMonth, setLimitMonth] = useState(3);
    const [description, setDescription] = useState('1、本报价含税价，乙方提供13%的增值税专用发票；');

    const cancel = () => {
        setOpen(false);
        setLoading(false);
        setAction(CNF.actionName.CREATE);
        setOfferLists([]);
        setName('');
        setVersion(1);
        setInitAmount(0);
        setInitTaxAmount(0);
        setAmount(0);
        setTaxAmount(0);
        setOfferSorts([{
            number: 1,
            name: '一、项目整体报价',
            rate: 1,
            tax_point: 0,
            amount: 0,
            tax_amount: 0,
        }]);
        setSortNumber(1);
        setIsDrawerOpen(false);
        setClientName('');
        setClientAddress('');
        setClientContacts('');
        setClientPhone('');
        setClientEmail('');
        setOfferName('');
        setOfferAddress('');
        setOfferContacts('');
        setOfferPhone('');
        setOfferEmail('');
        setOfferDate(currentDate);
        setLimitMonth(3);
        setDescription('');

    };

    useEffect(() => {
        /**
         * 获取报价分类
         * @param {*} record 
         */
        const getOfferSorts = (record) => {
            const params = {
                project_offer_ulid: record.key,
            };
            $.ajax({
                url: `${CNF.api}projects/offers/sorts${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setOfferSorts(data.dat);
                        } else {
                            setOfferSorts([]);
                        }
                    }
                }
            })
        }

        /**
         * 获取报价清单
         * @param {*} record 
         */
        const getOfferLists = (record) => {
            const params = {
                project_offer_ulid: record.key,
            };
            $.ajax({
                url: `${CNF.api}projects/offers/lists${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setOfferLists(data.dat);
                        } else {
                            setOfferLists([]);
                        }
                    }
                }
            })
        }
        // 修改初始化
        if (record) {
            getOfferSorts(record);
            getOfferLists(record);
            setAction(CNF.actionName.UPDATE);
            setName(record.name);
            setVersion(record.version);
            setInitAmount(record.init_amount);
            setInitTaxAmount(record.init_tax_amount);
            setAmount(record.amount);
            setTaxAmount(record.tax_amount);
            setClientName(record.client_name);
            setClientAddress(record.client_address);
            setClientContacts(record.client_contacts);
            setClientPhone(record.client_phone);
            setClientEmail(record.client_email);
            setOfferName(record.offer_name);
            setOfferAddress(record.offer_address);
            setOfferContacts(record.offer_contacts);
            setOfferPhone(record.offer_phone);
            setOfferEmail(record.offer_email);
            setOfferDate(record.offer_date);
            setLimitMonth(record.limit_month);
            setDescription(record.description);
        }
    }, [open, record]);

    useEffect(() => {
        // 初始化账户基础信息
        if (open && !userBasicInfo) {
            $.ajax({
                url: `${CNF.sealApi}users/securityinfo`,
                headers: AddRequestHeaders(),
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        setUserBasicInfo(data.dat);
                        setOfferContacts(data.dat.displayname);
                        setOfferPhone(data.dat.phone);
                        setOfferEmail(data.dat.email);
                    }
                }
            })
        }
    }, [open, userBasicInfo]);

    useEffect(() => {
        // 初始化组织信息
        if (open && !orgInfo) {
            const params = {
                prefix: preGroup,
            };
            $.ajax({
                url: `${CNF.sealApi}orgs/infos${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            // 使用组织信息作为报价基础信息
                            setOrgInfo(data.dat[0]);
                            setOfferName(data.dat[0].name);
                            setOfferAddress(data.dat[0].address);
                        }
                    }
                }
            })
        }

    }, [open, orgInfo, preGroup]);

    /**
     * 修改报价分类比率
     * 根据number值，找到分类比率
     * @param {*} value 
     */
    const changeOfferSortRate = (value) => {
        value = value === null ? 0 : value;
        // 调整比例后需要使用原始单价计算金额
        let ofLists = [];
        for (let i = 0; i < offerLists.length; i++) {
            let item = offerLists[i];
            if (item.sort_number === sortNumber) {
                // 在初始单价的基础上乘以比率
                // 计算单价
                let _price = parseFloat(item.init_price) * parseFloat(value);
                item.price = (parseInt(_price * 100) / 100).toFixed(CNF.DPL);
                // 计算金额
                let _amount = parseFloat(item.count) * parseFloat(item.price);
                item.amount = (parseInt(_amount * 100) / 100).toFixed(CNF.DPL);
                // 计算税额
                let _tax_amount = parseFloat(item.count) * parseFloat(item.price) * parseFloat(item.tax_point) / 100;
                item.tax_amount = (parseInt(_tax_amount * 100) / 100).toFixed(CNF.DPL);
            }
            ofLists.push(item);
        }
        // 修改报价分类比率
        let ofSorts = [];
        for (let i = 0; i < offerSorts.length; i++) {
            let item = offerSorts[i];
            if (item.number === sortNumber) {
                item.rate = value;
            }
            ofSorts.push(item);
        }
        setOfferSorts(ofSorts);
        setOfferLists(ofLists);
        sumAmount(ofLists);
    }

    /**
     * 修改报价分类税点
     * 根据sortNumber值，找到分类税点
     * @param {*} value 
     */
    const changeOfferSortTaxPont = (value) => {
        value = value === null ? 0 : value;
        //  调整税点后需要重新计算税金
        let ofLists = [];
        for (let i = 0; i < offerLists.length; i++) {
            let item = offerLists[i];
            if (item.sort_number === sortNumber) {
                item.tax_point = value;
                let _tax_amount = parseFloat(item.count) * parseFloat(item.price) * parseFloat(item.tax_point) / 100;
                item.tax_amount = (parseInt(_tax_amount * 100) / 100).toFixed(CNF.DPL);
            }
            ofLists.push(item);
        }
        //  修改报价分类税点
        let ofSorts = [];
        for (let i = 0; i < offerSorts.length; i++) {
            let item = offerSorts[i];
            if (item.number === sortNumber) {
                item.tax_point = value;
            }
            ofSorts.push(item);
        }
        setOfferSorts(ofSorts);
        setOfferLists(ofLists);
        sumAmount(ofLists);
    }
    /**
     * 修改报价分类名称
     * 根据sortNumber值，找到分类名称
     * @param {*} value 
     */
    const changeOfferSortName = (value) => {
        let ofSorts = [];
        for (let i = 0; i < offerSorts.length; i++) {
            let item = offerSorts[i];
            if (item.number === sortNumber) {
                item.name = value;
            }
            ofSorts.push(item);
        }
        setOfferSorts(ofSorts);
    }

    /**
     * 添加报价分类
     */
    const addOfferSort = () => {
        // 添加报价分类
        let ofSorts = [...offerSorts];
        ofSorts.push({
            number: offerSorts.length + 1,
            name: '',
            rate: 1,
            tax_point: 0,
            amount: 0,
            tax_amount: 0,
        });
        setOfferSorts(ofSorts);
        // 切换标签页
        setSortNumber(offerSorts.length + 1);
    }

    /**
     * 移除报价分类清单并重新调整分类编码
     * @param {*} key 
     */
    const removeOfferSortLists = (key) => {
        // 计算逻辑
        // 1.编码为1的是不能删除的；
        // 2.根据key值，将大于key值的分类编码减一
        let ofLists = [];
        for (let i = 0; i < offerLists.length; i++) {
            let item = offerLists[i];
            if (item.sort_number < key) {
                // 小于key值的无须修改
                ofLists.push(item);
            } else if (item.sort_number > key) {
                // 大于key值的分类编码-1
                item.sort_number -= 1;
                ofLists.push(item);
            } else {
                // 等于key值的删除
            }
        }
        setOfferLists(ofLists);
        sumAmount(ofLists);
    }

    /**
     * 移除报价分类
     * @param {*} key 
     */
    const removeOfferSort = (key) => {
        // 移除报价分类
        let ofSorts = [];
        for (let i = 0; i < offerSorts.length; i++) {
            let item = offerSorts[i];
            if (item.number < key) {
                // 小于key值的无须修改
                ofSorts.push(item);
            } else if (item.number > key) {
                // 大于key值的分类编码-1
                item.number -= 1;
                ofSorts.push(item);
            } else {
                // 等于key值的删除
            }
        }
        // 移除清单列表
        removeOfferSortLists(key);
        setOfferSorts(ofSorts);
        // 切换标签页
        setSortNumber(key - 1);
    }

    /**
     * 编辑分类页签
     * @param {*} targetKey 
     * @param {*} action 
     */
    const onTagEdit = (targetKey, action) => {
        // 添加或者移除报价分类
        if (action === 'add') {
            addOfferSort();
        } else if (targetKey) {
            removeOfferSort(targetKey);
        }
    }

    /**
     * 汇总金额
     * @param {*} ofLists 
     */
    const sumAmount = (ofLists) => {
        let initAmount = 0;     //  初始金额合计
        let initTaxAmount = 0;  //  初始税费合计
        let amount = 0;     //  金额合计
        let taxAmount = 0;  //  税费合计
        //  统计金额和税费
        for (let i = 0; i < ofLists.length; i++) {
            amount += parseFloat(ofLists[i].amount);
            taxAmount += parseFloat(ofLists[i].tax_amount);
            initAmount += parseFloat((parseFloat(ofLists[i].count) * parseFloat(ofLists[i].init_price)).toFixed(CNF.DPL));
            initTaxAmount += parseFloat((parseFloat(ofLists[i].count) * parseFloat(ofLists[i].init_price) * parseFloat(ofLists[i].tax_point) / 100).toFixed(CNF.DPL));
        }
        //  分类统计
        let soLists = [];
        for (let i = 0; i < offerSorts.length; i++) {
            let sortAmount = 0;     //  金额小计；
            let sortTaxAmount = 0;  //  税费小计；
            let sortItem = offerSorts[i];
            for (let j = 0; j < ofLists.length; j++) {
                let listItem = ofLists[j];
                if (sortItem.number === listItem.sort_number) {
                    sortAmount += parseFloat(listItem.amount);
                    sortTaxAmount += parseFloat(listItem.tax_amount);
                }
            }
            let item = offerSorts[i];
            item.amount = sortAmount;
            item.tax_amount = sortTaxAmount;
            soLists.push(item);
        }
        setOfferSorts(soLists);
        setAmount(amount.toFixed(CNF.DPL));
        setTaxAmount(taxAmount.toFixed(CNF.DPL));
        setInitAmount(initAmount.toFixed(CNF.DPL));
        setInitTaxAmount(initTaxAmount.toFixed(CNF.DPL));
    }

    /**
     * 添加产品
     * @param {*} record 
     */
    const addProduct = (record) => {
        // 判断该产品是否已添加，已添加则数量+1
        let isExist = false;
        let ofLists = [];
        for (let i = 0; i < offerLists.length; i++) {
            ofLists.push(offerLists[i]);
        }
        for (let i = 0; i < ofLists.length; i++) {
            if (ofLists[i].number === record.number && ofLists[i].sort_number === sortNumber) {
                isExist = true;
                // 数量 + 1
                ofLists[i].count = parseFloat(ofLists[i].count) + 1;
                // 计算单项金额
                ofLists[i].amount = (parseFloat(ofLists[i].count) * parseFloat(ofLists[i].price)).toFixed(CNF.DPL);
                // 计算单项税费
                ofLists[i].tax_amount = (parseFloat(ofLists[i].count) * parseFloat(ofLists[i].price) * parseFloat(ofLists[i].tax_point) / 100).toFixed(CNF.DPL);
                setOfferLists(ofLists);
                break;
            }
        }
        if (!isExist) {
            // 分类税点
            let taxPoint = parseInt(offerSorts[parseInt(sortNumber) - 1].tax_point);
            // 分类比率
            let rate = parseFloat(offerSorts[parseInt(sortNumber) - 1].rate);
            let item = {
                // 税点可以单项条整
                // 报价比率就不单项调整了，因为通过比率调整单价，操作难度大
                // 若后续需要计算比率，可以通过初始价与现有价格换算得到
                'key': record.number + sortNumber,
                'number': record.number,
                'name': record.name,
                'description': record.description,
                'remarks': record.remarks,
                'brand': record.brand,
                'model': record.model,
                'unit': record.unit,
                'count': 1,
                'init_price': record.price,                          //  初始单价
                'tax_point': taxPoint,                               //  税点
                'sort_number': sortNumber,                           //  分类编码    
                'amount': (record.price * rate).toFixed(CNF.DPL),    //  金额 
                'price': (record.price * rate).toFixed(CNF.DPL),
                'tax_amount': (record.price * taxPoint * rate / 100).toFixed(CNF.DPL) //  税金
            }
            //  直接添加
            ofLists.push(item);
            setOfferLists(ofLists);
        }
        sumAmount(ofLists);
    }

    /**
     * 移除产品
     * @param {*} record 
     */
    const removeProduct = (record) => {
        //  删除某项报价清单
        let ofLists = offerLists.filter(item => item !== record);
        setOfferLists(ofLists);
        sumAmount(ofLists);
    }

    /**
     * 修改数量
     * @param {*} record 
     * @param {*} count 
     */
    const updateCount = (record, count) => {
        count = count === null ? 0 : count;
        let ofLists = [];
        for (let i = 0; i < offerLists.length; i++) {
            let item = offerLists[i];
            if (item.number === record.number && item.sort_number === sortNumber) {
                // 修改数量
                item.count = count;
                let _amount = parseFloat(item.count) * parseFloat(item.price);
                item.amount = (parseInt(_amount * 100) / 100).toFixed(CNF.DPL);
                let _tax_amount = parseFloat(item.count) * parseFloat(item.price) * parseFloat(item.tax_point) / 100;
                item.tax_amount = (parseInt(_tax_amount * 100) / 100).toFixed(CNF.DPL);
            }
            ofLists.push(item)
        }
        setOfferLists(ofLists);
        sumAmount(ofLists);
    }

    /**
     * 修改单价
     * @param {*} record 
     * @param {*} count
     */
    const updatePrice = (record, price) => {
        price = price === null ? 0 : price;
        let ofLists = [];
        for (let i = 0; i < offerLists.length; i++) {
            let item = offerLists[i]
            if (item.number === record.number && item.sort_number === sortNumber) {
                // 修改单价
                item.price = price;
                let _amount = parseFloat(item.count) * parseFloat(item.price);
                item.amount = (parseInt(_amount * 100) / 100).toFixed(CNF.DPL);
                let _tax_amount = parseFloat(item.count) * parseFloat(item.price) * parseFloat(item.tax_point) / 100;
                item.tax_amount = (parseInt(_tax_amount * 100) / 100).toFixed(CNF.DPL);
            }
            ofLists.push(item)
        }
        setOfferLists(ofLists);
        sumAmount(ofLists);
    }

    /**
     * 修改税点
     * @param {*} record 
     * @param {*} value
     */
    const updateTaxPoint = (record, value) => {
        value = value === null ? 0 : value;
        let ofLists = [];
        for (let i = 0; i < offerLists.length; i++) {
            let item = offerLists[i];
            if (item.number === record.number && item.sort_number === sortNumber) {
                // 修改税点
                item.tax_point = value;
                let _tax_amount = parseFloat(item.count) * parseFloat(item.price) * parseFloat(item.tax_point) / 100;
                item.tax_amount = (parseInt(_tax_amount * 100) / 100).toFixed(CNF.DPL);
            }
            ofLists.push(item)
        }
        setOfferLists(ofLists);
        sumAmount(ofLists);
    }

    /**
     * 修改备注
     * @param {*} record 
     * @param {*} value
     */
    const updateRemarks = (record, value) => {
        let ofLists = [];
        for (let i = 0; i < offerLists.length; i++) {
            let item = offerLists[i];
            if (item.number === record.number && item.sort_number === sortNumber) {
                item.remarks = value;
            }
            ofLists.push(item)
        }
        setOfferLists(ofLists);
    }

    const ok = () => {
        //  参数校验
        if (name === '') {
            messageApi.error('报价名称不能为空！', CNF.messageDuration);
            return;
        }
        if (version < 1) {
            messageApi.error('报价版本不能为空！', CNF.messageDuration);
            return;
        }
        if (offerLists.length < 1) {
            messageApi.error('报价清单不能为空！', CNF.messageDuration);
            return;
        }
        // 开启动作保护，防止多次点击
        setLoading(true);
        $.ajax({
            url: CNF.api + MODULENAME_URL.slice(1) + (action === CNF.actionName.UPDATE ? '/' + record.key : ''),
            headers: AddRequestHeaders(),
            type: action === CNF.actionName.UPDATE ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                name: name,
                version: version,
                limit_month: limitMonth,
                offer_sorts: offerSorts,
                offer_lists: offerLists,
                init_amount: initAmount,
                init_tax_amount: initTaxAmount,
                amount: amount,
                tax_amount: taxAmount,
                client_name: clientName,
                client_address: clientAddress,
                client_contacts: clientContacts,
                client_phone: clientPhone,
                client_email: clientEmail,
                offer_name: offerName,
                offer_address: offerAddress,
                offer_contacts: offerContacts,
                offer_phone: offerPhone,
                offer_email: offerEmail,
                offer_date: offerDate,
                description: description,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    refresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        }).always(() => setTimeout(function () {
            setLoading(false)
        }, CNF.messageDuration * 1000))
    };

    return (
        <ConfigProvider
            theme={{
                components: {
                    Tabs: {
                        horizontalItemPadding: '0 0',
                        cardPaddingSM: '3px 0',
                    },
                },
            }}
        >
            {contextHolder}
            <Modal
                width={winWidth > 200 ? winWidth - 200 : winWidth}
                height={winHeight}
                title='项目报价管理'
                style={{ top: 0, left: 100 }}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='保存'
                cancelText='取消'
                footer={null}
                okButtonProps={{ disabled: loading }}
            >
                <Flex vertical gap='small'>
                    <ProductTable
                        record={record}
                        btnLists={btnLists}
                        addProduct={addProduct}
                    />

                    <Space>
                        <Input
                            placeholder='项目名称'
                            style={{ minWidth: 300 }}
                            onChange={(e) => setName(e.target.value)}
                            value={name}
                            disabled={loading}
                        />
                        <InputNumber
                            placeholder='版本号'
                            prefix='版本号 v: '
                            style={{ width: 130 }}
                            min={1}
                            step={1}
                            onChange={(value) => setVersion(value)}
                            value={version}
                            disabled={loading}
                        />
                        <InputNumber
                            onChange={(value) => changeOfferSortRate(value)}
                            placeholder='调整比'
                            prefix='调整比: '
                            style={{ width: 130 }}
                            min={0}
                            step='0.01'
                            value={offerSorts.length > 0 ? offerSorts[parseInt(sortNumber) - 1].rate : 1}
                            disabled={loading}
                        />
                        <InputNumber
                            onChange={(value) => changeOfferSortTaxPont(value)}
                            placeholder='税率点'
                            prefix='税率点: '
                            style={{ width: 130 }}
                            min={0}
                            max={45}
                            step={1}
                            value={offerSorts.length > 0 ? offerSorts[parseInt(sortNumber) - 1].tax_point : 0}
                            disabled={loading}
                        />
                        <Button
                            type='primary'
                            onClick={() => { setIsDrawerOpen(true) }}
                            style={{ width: '100%' }}
                        >更多</Button>
                        {
                            // 审核后只能复制, 不能修改
                            // 修改操作状态下, 可以切换为新增或修改
                            (action === CNF.actionName.UPDATE || offerLists.length > 0) && record && record.status !== CNF.offerStatus[1].value && (
                                <Radio.Group
                                    onChange={(e) => setAction(e.target.value)}
                                    value={action}
                                    options={[
                                        {
                                            label: CNF.actionName.CREATE,
                                            value: CNF.actionName.CREATE,
                                        },
                                        {
                                            label: CNF.actionName.UPDATE,
                                            value: CNF.actionName.UPDATE,
                                        },
                                    ]}
                                    optionType='button'
                                    disabled={loading}
                                />)
                        }
                        <Button
                            type='primary'
                            onClick={() => { ok() }}
                            disabled={loading}
                        >保存</Button>
                    </Space>
                    <Tabs
                        // hideAdd
                        size={'small'}
                        style={{ width: '100%' }}
                        onChange={(key) => setSortNumber(key)}
                        activeKey={sortNumber}
                        type='editable-card'
                        onEdit={onTagEdit}
                        items={offerSorts.map((item) => {
                            /**
                             * 报价默认只有一个分类，名称为“一、项目整体报价”，支持修改，若只有一个分类，打印时报价不分类
                             * 根据报价分类，重新封装Tags列表
                            */
                            return {
                                closable: item.number === 1 ? false : true,
                                key: item.number,
                                label: <Input
                                    placeholder='请输入报价分类名'
                                    style={{ height: '20px', color: colorPrimary, width: '165px' }}
                                    value={item.name}
                                    onChange={(e) => changeOfferSortName(e.target.value)}
                                    variant='borderless'
                                />,
                                children: <OfferList
                                    btnLists={btnLists}
                                    dataLists={offerLists.filter(item => item.sort_number === sortNumber)}
                                    offerSorts={offerSorts}
                                    sortNumber={sortNumber}
                                    removeProduct={removeProduct}
                                    updateCount={updateCount}
                                    updatePrice={updatePrice}
                                    updateTaxPoint={updateTaxPoint}
                                    updateRemarks={updateRemarks}
                                    amount={amount}
                                    taxAmount={taxAmount}
                                    operation={CNF.actionName.CREATE}
                                    changeAmount={setAmount}
                                />
                            }
                        })}
                        defaultActiveKey={1}
                        disabled={loading}
                    />
                </Flex>
                <Drawer
                    title='报价详细信息'
                    placement='right'
                    size={620}
                    onClose={() => { setIsDrawerOpen(false) }}
                    open={isDrawerOpen}
                    extra={
                        <Space>
                            {/* <Button onClick={()=>{setIsDrawerOpen(false)}}>取消</Button> */}
                            <Button type='primary' onClick={() => { setIsDrawerOpen(false) }}>确定</Button>
                        </Space>
                    }
                >
                    <Flex vertical gap='small'>
                        <Row>
                            <Col span={24}>客户名称</Col>
                            <Col span={24}>
                                <Input
                                    placeholder='请输入'
                                    style={{ width: '100%' }}
                                    onChange={(e) => setClientName(e.target.value)}
                                    value={clientName}

                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>地址</Col>
                            <Col span={24}>
                                <Input
                                    placeholder='请输入'
                                    style={{ width: '100%' }}
                                    onChange={(e) => setClientAddress(e.target.value)}
                                    value={clientAddress}

                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>联系人</Col>
                            <Col span={24}>
                                <Input
                                    placeholder='请输入'
                                    style={{ width: '100%' }}
                                    onChange={(e) => setClientContacts(e.target.value)}
                                    value={clientContacts}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={10}>电话</Col>
                            <Col span={13} offset={1}>邮箱</Col>
                            <Col span={10}>
                                <Input
                                    placeholder='请输入'
                                    style={{ width: '100%' }}
                                    onChange={(e) => setClientPhone(e.target.value)}
                                    value={clientPhone}

                                />
                            </Col>
                            <Col span={13} offset={1}>
                                <Input
                                    placeholder='请输入'
                                    style={{ width: '100%' }}
                                    onChange={(e) => setClientEmail(e.target.value)}
                                    value={clientEmail}

                                />
                            </Col>
                        </Row>
                        <Divider />
                        <Row>
                            <Col span={24}>报价单位</Col>
                            <Col span={24}>
                                <Input
                                    style={{ width: '100%' }}
                                    onChange={(e) => setOfferName(e.target.value)}
                                    value={offerName}

                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>地址</Col>
                            <Col span={24}>
                                <Input
                                    placeholder='请输入'
                                    style={{ width: '100%' }}
                                    onChange={(e) => setOfferAddress(e.target.value)}
                                    value={offerAddress}

                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>联系人</Col>
                            <Col span={24}>
                                <Input
                                    placeholder='请输入'
                                    style={{ width: '100%' }}
                                    onChange={(e) => setOfferContacts(e.target.value)}
                                    value={offerContacts}

                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={10}>电话</Col>
                            <Col span={13} offset={1}>邮箱</Col>
                            <Col span={10}>
                                <Input
                                    placeholder='请输入'
                                    style={{ width: '100%' }}
                                    onChange={(e) => setOfferPhone(e.target.value)}
                                    value={offerPhone}
                                />
                            </Col>
                            <Col span={13} offset={1}>
                                <Input
                                    placeholder='请输入'
                                    style={{ width: '100%' }}
                                    onChange={(e) => setOfferEmail(e.target.value)}
                                    value={offerEmail}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={10}>时间</Col>
                            <Col span={13} offset={1}>时效</Col>
                            <Col span={10}>
                                <DatePicker
                                    placeholder='请选择日期'
                                    style={{ width: '100%' }}
                                    onChange={(_, dateString) => setOfferDate(dateString)}
                                    value={dayjs(offerDate, 'YYYY-MM-DD')}
                                />
                            </Col>

                            <Col span={13} offset={1}>
                                <InputNumber
                                    placeholder='有效期(月)'
                                    style={{ width: '100%' }}
                                    prefix='有效期(月): '
                                    min={1}
                                    max={12}
                                    step={1}
                                    onChange={(value) => setLimitMonth(value)}
                                    value={limitMonth}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>备注</Col>
                            <Col span={24}>
                                <TextArea
                                    style={{ width: '100%' }}
                                    autoSize={{ minRows: 6, maxRows: 8 }}
                                    onChange={(e) => setDescription(e.target.value)}
                                    value={description}
                                />
                            </Col>
                        </Row>
                    </Flex>
                </Drawer>
            </Modal>
        </ConfigProvider>
    );
}

export default Entity